<template>
  <b-modal id="modal-request-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form  >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-calendar"></em> Work from Home Request</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{emp_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Reason</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <hr>
              <legend><em class="fa fa-book"></em> Work from Home - Duty and Project</legend>
              <div class="form-group">
                <div class="table-responsive">
                  <table class="table table-hover table-striped" aria-describedby="Work from Home">
                    <thead>
                    <tr>
                      <th style="width:50px" id="no">No</th>
                      <th style="width:150px" id="project">Project</th>
                      <th style="width:150px" id="date">Date</th>
                      <th style="width:150px" id="hours">Hours</th>
                      <th style="width:150px" id="notes">Notes</th>
                    </tr>
                    </thead>
                    <tbody id="tickets-body">
                    <tr v-for="(item, i) in items">
                      <td>{{i+1}}</td>
                      <td>{{item.project_name}}</td>
                      <td>{{item.date}}</td>
                      <td>{{item.hours}}</td>
                      <td>{{item.notes}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.wfh_stat_id)"></list-supervisor-finish>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";
import ListSupervisor from "../employee/ListSupervisor";

export default {
  name: "WorkFromHomeDetail",
  components:{
    ListSupervisor,
    ListSupervisorFinish,
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      emp_name:{},
      detail:{},
      items:[],
      list_supervisor:[],
      arr_status:[0,1]
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          AxiosCall.Get({id:this.data.id}, urlApi.wfh.detail).then(res=>{
            if(res.success){
              this.detail.reason = res.atributes.reason
              this.detail.emp_id = res.atributes.emp_id
              this.detail.wfh_stat_id = res.atributes.wfh_stat_id
              this.items = JSON.parse(res.atributes.items)
              if(!this.arr_status.includes(res.atributes.wfh_stat_id)) this.getListSupervisor()
            }else{
              this.$parent.errorMessage(res.message)
            }
          }).catch(e=>{
            this.$parent.errorMessage(e.response.data.message)
          })
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.$refs.modal.hide()
    },
    getListSupervisor(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.wfh.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  },
  mounted() {
    let userProfile = this.$store.getters.userProfile.data.attributes
    this.emp_name = userProfile.emp_name
  }
}
</script>